import * as types from "@/store/constants/types";
export default {
  [types.RECEIVE_GX_MASTER_SERVER_DATA](state: any, payLoad: any) {
    //做merge操作，后台返回的字段可能部分缺失： conntection,
    // let original_services = state.gxUserInfo.services ? state.gxUserInfo.services : []
    state.gxUserInfo = {
      ...state.gxUserInfo,
      ...payLoad
    };
    // services列表的深合并
    // if (payLoad.services && payLoad.services.length > 0) {
    //   original_services = original_services.concat(payLoad.services)
    //   const merge_services: any = []
    //   for (const item of original_services) {
    //     const index: any = merge_services.findIndex((v: any) => v.offer_id === item.offer_id)
    //     if (index > -1) {
    //       merge_services.splice(index, 1, item)
    //     } else {
    //       merge_services.push(item)
    //     }
    //   }
    //   state.gxUserInfo.services = merge_services
    // }
  },
  [types.RECEIVE_GX_SERVICE_LIST](state: any, payLoad: any) {
    state.gxServiceList = payLoad;
  },
  [types.RECEIVE_SUBS_LIST](state: any, payLoad: any) {
    state.subsList = payLoad;
  },
  [types.UPDATE_FREE_FOLLOWERS_ENABLE_STATE](state: any) {
    state.freeFollowersEnable = false
  },
  [types.DELETE_EXTRA_PROPERTY](state: any, payLoad: any) {
    delete state.gxUserInfo[payLoad]
  }
};
